import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {sendInput} from "game/app/actions/game-instance-actions";
import GameComponent from "game/app/components/game/game-component";
import QuestionForm from "../../../common/question-form";
import GameInstance from "common/models/game-instance";
import {Link} from "react-router-dom";

class Category extends GameComponent {

    sendAnswer = (values, form) => {
        this.props.sendInput(this.getInstanceId(), { type: 'answer', answer: values });
    };

    render() {
        if (this.props.knowledgeQuestions.loading) {
            return (<div>Loading</div>);
        }

        let descriptions = this.getProfileProperty('CATEGORY_DESCRIPTIONS');

        let category_id = this.props.match.params.category_id;
        let answers = this.props.gameInstance.instance.answers;
        let current_round = this.isCurrentNodeType('Nodes::Round02Node');
        let instance_id = this.getInstanceId();

        let questions = this.props.knowledgeQuestions.list
            .filter((question) => question.properties.category === category_id)
            .map((question) => {
                let answer = answers.find((answer) => answer.luduengine_knowledge_question_id === question.id);
                return (<QuestionForm key={question.id} className='question' question={question} answer={answer} handleSubmit={this.sendAnswer} active={current_round} instanceId={instance_id} />)
            });

        return (
            <div className='container'>
                <div className='row'>
                    <div className={this.mainContainerClass}>
                        <h1 className='page-title-minor separate-bottom'>Úkoly - { GameInstance.getCategoryTitle(category_id) }</h1>
                        { descriptions && descriptions[category_id] &&
                            <div className='separate'>{ descriptions[category_id] }</div>
                        }
                        <p className='label'>Základní úkoly</p>
                        { questions }
                    </div>
                </div>
                <div className='separate text-center'><Link to={`/game/${this.getInstanceId()}/round-2/otazky`} className='btn btn-primary'>K dalším úkolům</Link></div>
            </div>
        )
    }

}

function mapStateToProps(state,ownProps) {
    return {
        gameInstance: state.gameInstance,
        knowledgeQuestions: state.knowledgeQuestions
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        sendInput: sendInput
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Category);
